module.exports = __webpack_public_path__ + "media/images/icons/outlined/cloud-download-a999f93493ad7a6034ecb0240deb7f85.svg";